import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import runScenario from './run-scenario';
import { MIN_DTI, DTI_ADJUSTMENT } from '../data/constants';
export default function validateMortgageInsurance(insurance, inputs, outputs, condition) {
  var overrideDti = inputs.dti;
  var minDti = MIN_DTI;
  while (overrideDti > minDti) {
    overrideDti -= DTI_ADJUSTMENT;
    var candidate = runScenario(insurance, _objectSpread(_objectSpread({}, inputs), {}, {
      dti: overrideDti
    }), outputs);
    if (condition(candidate)) {
      return candidate;
    }
  }
  return null;
}